export default __webpack_public_path__ + "static/media/prysmatic-labs-circle.e62ca767.png";